// extracted by mini-css-extract-plugin
export default {"container":"login_container__P0FSm","wrapper":"login_wrapper__p-L8E"};